import styled from '@emotion/styled';

export const ConferenceContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
`;
export const ContentTabList = styled.div`
	max-width: 135rem;
	width: 100%;
	margin: 0 auto;
`;
export const ConferenceTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.size6xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
	text-align: left;
`;

export const ConferenceSearchBox = styled.div`
	display: flex;
	gap: 0.4rem;
	justify-content: flex-end;
	width: 100%;
	height: 4.4rem;
`;

export const ConferenceBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ConferenceGalleryBox = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 2rem;
	width: 100%;
	@media screen and (max-width: 1370px) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media screen and (max-width: 1024px) {
		grid-template-columns: repeat(2, 1fr);
	}
	@media screen and (max-width: 768px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;
export const GalleryItemBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	min-width: 0; /* ✅ 부모보다 커지지 않도록 강제 */
	cursor: pointer;
	.img_box {
		width: 100%;
		height: 22rem;
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;

	/* max-width: 32.2rem;
	width: 100%; */

	.title {
		font-size: ${(props) => props.theme.fontSize.sizeXl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: 130%;
		letter-spacing: -0.6px;
		color: #212529;
		width: 100%;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.date {
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		font-weight: ${(props) => props.theme.fontWeight.weightRegular};
		line-height: 100%;
		letter-spacing: -0.6px;
		color: #868e96;
	}
`;
export const ConferenceGalleryImgBox = styled.div`
	height: 22rem;
`;
export const EmptyData = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	text-align: center;
`;

// Team Page
// 조직구성 하위 리스트 컨테이너
export const TeamListSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4.8rem; /* 48px */
`;

// 카드들을 담는 래퍼: 가로로 최대 3개, 초과 시 줄바꿈
export const TeamCardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4rem; /* 카드 간격 40px */
  width: 100%;
  @media screen and (max-width: 900px) {
    gap: 2rem;
  }
`;

// 단일 카드
export const TeamCard = styled.article`
  display: flex;
  width: 423.333px;
  min-height: 436px;
  padding: 48px;
  align-items: flex-start;
  gap: 0; /* 상단/본문 간격은 내부 컨테이너에서 제어 */
  flex: 0 0 423.333px; /* 3열 고정 배치 */
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--color-white, #fff);
  box-shadow: 0 16px 40px 0 rgba(154, 154, 154, 0.2);

  @media screen and (max-width: 900px) {
    width: 100%;
    flex: 1 0 100%;
    padding: 24px;
  }
`;

// 카드 내 좌측(혹은 상단) 정보 블록: 직급/이름
// 카드 내부 전체 레이아웃: 상단(직급/이름)과 하단(주요 경력) 사이 간격 50px
export const TeamCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  flex: 1 0 0;
  align-self: stretch;
`;

// 상단 헤더: 직급(좌) / 이름(우)
export const TeamCardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  min-height: 96px;
  @media screen and (max-width: 900px) {
    min-height: 72px;
  }
`;

// 직급 블록
export const TeamCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

export const TeamCardPosition = styled.span<{ isCeo?: boolean }>`
  color: ${({ isCeo }) => (isCeo ? '#004ED8' : '#222')};
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.72px;
`;

export const TeamCardName = styled.h3`
  color: var(--color-font-default, #222);
  font-family: 'Pretendard Variable';
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -1.12px;
  @media screen and (max-width: 900px) {
    font-size: 24px;
  }
`;

// 직급 배지(대표이사: 하늘색, 기타: 회색)
export const PositionBadge = styled.div<{ isCeo?: boolean }>`
  display: flex;
  height: 44px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 9999px;
  background: ${({ isCeo }) => (isCeo ? '#EBF1FF' : '#ECECEC')};
`;

// 카드 본문(주요 경력 영역 컨테이너)
export const TeamCardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

export const ExperienceTitle = styled.h4`
  color: #222;
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.72px;
`;

export const ExperienceList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ExperienceItem = styled.li`
  color: var(--color-font-default, #222);
  font-family: 'Pretendard Variable';
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 133.333% */
  letter-spacing: -0.72px;
`;

export const ExperienceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`;

export const BulletDot = styled.span`
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #004ED8;
  flex: 0 0 auto;
`;

// 상단과 하단 사이 가변 간격: 최소 50px 보장, 남는 공간을 차지하여 본문을 하단 정렬
export const TeamCardSpacer = styled.div`
  flex: 0 0 24px;
  width: 100%;
`;
